import ExternalLinkButton from './ExternalLinkButton'

export default ExternalLinkButton
